module.exports = __webpack_public_path__ + "fonts/icomoon.4d35e8f.woff";